export default "__VITE_ASSET__C6mGC6uY__"